import { Component } from '@angular/core';

@Component({
  selector: 'app-tourism',
  templateUrl: './tourism.component.html',
  styleUrl: './tourism.component.scss'
})
export class TourismComponent {

}
